export const formatTime = (ms: number): string => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000)); // マイナスにならないように
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};